import constants from '../constants/createAccount';

const validateEmail = email => {
  const re = /^\S+@\S+\.\S+$/i;
  return re.test(String(email)) && email.length <= constants.emailMaxLength;
};
export default validateEmail;
